import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const dotIcon = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5" cy="5" r="4" fill="currentColor" />
  </svg>
);

export const DotIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={dotIcon} {...props} />
);
